import { ELayoutType } from '../../../../api-models/common/json_query';

export const LAYOUT_TYPE_VALUE_TO_LABEL = {
  [ELayoutType.IsolatedRooms]: 'Изолированные',
  [ELayoutType.UnitedRooms]: 'Смежные',
};
